import { useAuth0 } from "@auth0/auth0-react";
import { getSharedConnectors } from "api/ComponentsApi";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setSharedConnectors } from "redux/actions/portal/connectorsActionCreator";

export const useSharedConnectors = () => {
  const dispatch = useDispatch();
  const { user } = useAuth0();
  const { sharedConnectors } = useSelector((store) => store.portal.connectors);

  const handleFetchSharedConnectors = async () => {
    const sharedConnectorsResponse = await getSharedConnectors(user.stripeId);

    dispatch(setSharedConnectors(sharedConnectorsResponse.resultObject));
  };

  useEffect(() => {
    if (!user?.stripeId || sharedConnectors.length) return;

    handleFetchSharedConnectors();
  }, [user?.stripeId]);

  return {
    sharedConnectors,
    handleFetchSharedConnectors
  };
};
